import '../styles/CustomCheckbox.css';

export function CustomCheckbox({label, checked, onChange, disableButtons}) {
  return (
    <label className="checkbox">
      <input type="checkbox" checked={checked} disabled={disableButtons} onChange={e => onChange(e.target.checked)} />
      <span>{label}</span>
    </label>
  );
}
